module.exports = __webpack_public_path__ + "img/47_23.e207720c.png";